(function () {
    'use strict';

    angular
        .module('sodCommon')
        .factory('action-console-log', actionFunc);

    function actionFunc(lodash, $q, $injector) {
        /**
         * Action have 2 main functionality.
         *  1. Allow you to select the type of model (eventData, actionResponse),
         *  2. Allow you to append the model,
         *         to append the model. "target" field is required.
         *         if value is provided, value will be append to the return data.
         *         value takes precedent over source. Both cannot be used together for now.
         */
        return function (options, eventData, actionResponse) {
            return $q.when(run());

            function run() {
                console.log(actionResponse, eventData);
            }
        }
    }
})();